export const isInViewport = (el) => {
  const props = el.getBoundingClientRect()
  return window.innerHeight > props.top && ~~(props.top + props.height) > 0
}

export const findPrevious = (item, arr) => {
  const currentIndex = arr.indexOf(item)
  return currentIndex > 0 && arr[currentIndex - 1]
}

export const findNext = (item, arr) => {
  const currentIndex = arr.indexOf(item)
  return currentIndex + 1 < arr.length && arr[currentIndex + 1]
}

export const isOverlappingVertically = (rect1, rect2) => (
  rect1.top <= rect2.bottom && rect2.top <= rect1.bottom
)



// WEBPACK FOOTER //
// ./src/assets/js/utils.js